import React from 'react';
import { IconButton, Grid, Box, Card, CardContent, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Delete, ZoomOutMap } from '@material-ui/icons';
import { toTemplateDropdownOptions } from 'views/Campaign/helpers';
import TemplateSingleSelect from 'components/TemplateSingleSelect';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  button: {
    margin: theme.spacing(1)
  },
  deleteButton: {
    color: theme.palette.error.main
  },
  openButton: {
    color: theme.palette.primary.main
  },
  selectContainer: {
    display: 'inline',
    minWidth: '14rem',
    margin: theme.spacing(1)
  },
  buttonContainer: {
    display: 'inline',
    margin: theme.spacing(1)
  },
  dateField: {
    width: '100%',
    marginTop: '0px'
  }
}));

const DefaultTemplate = props => {
  const {
    className,
    campaign,
    templates,
    paginatedTemplates,
    templateFilters,
    isTemplateDropdownLoading,
    isTemplateNameHydrationLoading,
    templateSelectedNamesByUuid,
    hierarchyFilterOptions,
    selectedHierarchyValues,
    selectedStatusValues,
    tagFilterOptions,
    selectedTagValues,
    onTemplateDropdownOpen,
    onTemplateHierarchyChange,
    onTemplateStatusChange,
    onTemplateTagChange,
    onTemplateSearchChange,
    onTemplatePageChange,
    onTemplateRowsPerPageChange,
    addDefaultTemplate,
    onEditTemplate,
    ...rest
  } = props;
  const {
    thisCampaign,
    handleChange,
    onBlur,
    onFocus,
    shouldShowError,
    getErrorMessage,
    removeDefaultTemplate,
    isCampaignReadOnly
  } = campaign;

  const classes = useStyles();
  const toOptions =
    typeof toTemplateDropdownOptions === 'function'
      ? toTemplateDropdownOptions
      : values => values;
  const availablePaginatedTemplates = Array.isArray(paginatedTemplates)
    ? paginatedTemplates
    : templates;

  const selectedTemplate = availablePaginatedTemplates.find(
    template => template.uuid === thisCampaign.communicationTemplateUuid
  );

  const defaultTemplateOptions = toOptions(availablePaginatedTemplates).map(
    option => ({
      ...option,
      disabled: option?.active === false
    })
  );

  const defaultTemplates = {
    list: defaultTemplateOptions,
    keyId: 'uuid',
    valueId: 'uuid',
    displayValueId: 'name'
  };

  if (thisCampaign.communicationTemplateUuid === undefined) {
    return null;
  }

  return (
    <Card style={{ marginTop: 10 }}>
      <CardContent>
        <Box>
          <Grid container>
            <Grid item className={classes.selectContainer}>
              <TemplateSingleSelect
                fullWidth
                label="Select a default template"
                margin="dense"
                name="communicationTemplateUuid"
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                disabled={isCampaignReadOnly()}
                value={thisCampaign.communicationTemplateUuid || ''}
                selectedDisplayValue={
                  selectedTemplate?.name ||
                  templateSelectedNamesByUuid?.[
                    thisCampaign.communicationTemplateUuid
                  ] ||
                  ''
                }
                error={shouldShowError('communicationTemplateUuid')}
                helperText={getErrorMessage('communicationTemplateUuid')}
                options={defaultTemplates}
                remotePagination
                totalCount={templateFilters?.totalCount || 0}
                isLoading={isTemplateDropdownLoading}
                showFieldSkeleton={isTemplateNameHydrationLoading}
                hierarchyOptions={hierarchyFilterOptions}
                selectedHierarchyValues={selectedHierarchyValues}
                selectedStatusValues={selectedStatusValues}
                tagOptions={tagFilterOptions}
                selectedTagValues={selectedTagValues}
                onOpen={onTemplateDropdownOpen}
                onHierarchyChange={onTemplateHierarchyChange}
                onStatusChange={onTemplateStatusChange}
                onTagChange={onTemplateTagChange}
                onSearchChange={onTemplateSearchChange}
                onPageChange={onTemplatePageChange}
                onRowsPerPageChange={onTemplateRowsPerPageChange}
                emptyStateText="No templates found"
                dataTestId="select-communicationTemplateUuid"
              />
            </Grid>

            {thisCampaign.communicationTemplateUuid && (
              <Grid item className={classes.buttonContainer}>
                <Tooltip title="Open">
                  <IconButton
                    className={classes.openButton}
                    onClick={() => onEditTemplate(thisCampaign.communicationTemplateUuid)}>
                    <ZoomOutMap />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}

            {!isCampaignReadOnly() && (
              <Grid item className={classes.buttonContainer}>
                <Tooltip title="Delete">
                  <IconButton
                    className={classes.deleteButton}
                    onClick={removeDefaultTemplate}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DefaultTemplate;
